"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
class BlockChainError extends Error {
  constructor(message) {
    super(message);
    this.name = "BlockChainError";
  }
}
exports.default = BlockChainError;